import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, number, func, arrayOf, string, bool } from 'prop-types'

import MediaCarousel from
  'Pods/LazyLoaded/UseCaseAreaSidebar/Components/UseCaseMediaViewer/Components/MediaCarousel/MediaCarousel'

import LikeDislikeButton from './Components/LikeDislikeButton/LikeDislikeButton'

function MediaCard({
  useCase,
  currentIndex,
  onUseCaseClick,
  onMediaNav,
  onLike: handleLike,
  onUnlike: handleUnlike,
  canUseLikeFeature,
  itemId = null,
  className = '',
  isNavHidden = false,
  useLargeImage = false,
}) {
  const handleMediaNav = (e, directionOrIndex) => {
    e.stopPropagation()
    if (!isNavHidden) {
      onMediaNav(useCase.id, directionOrIndex)
    }
  }

  const onUseCaseKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      e.stopPropagation()
      onUseCaseClick(useCase, currentIndex)
    }
  }

  return (
    <div className={classnames('use-case-media-card', className)}>
      <div
        className="use-case-media-card__content"
        onClick={() => onUseCaseClick(useCase, currentIndex)}
        role="button"
        tabIndex={0}
        onKeyDown={onUseCaseKeyPress}
        style={{ cursor: 'pointer' }}
      >
        <MediaCarousel
          embeds={useCase.useCaseEmbeds}
          currentIndex={currentIndex}
          isGalleryView={false}
          isMobile={false}
          onPrevious={(e) => handleMediaNav(e, 'prev')}
          onNext={(e) => handleMediaNav(e, 'next')}
          onDotClick={(e, index) => handleMediaNav(e, index)}
          isNavHidden={isNavHidden}
          useLargeImage={useLargeImage}
        />
        {canUseLikeFeature && itemId && currentIndex === 0 && (
          <div
            className="use-case-media-card__like-wrapper"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            role="presentation"
          >
            <LikeDislikeButton
              useCaseId={useCase.id}
              likeCount={useCase.likeCount}
              isLiked={useCase.liked}
              itemId={itemId}
              onLike={handleLike}
              onUnlike={handleUnlike}
              isLoading={useCase.isLoading}
            />
          </div>
        )}
      </div>
    </div>
  )
}

MediaCard.propTypes = {
  useCase: shape({
    id: string.isRequired,
    likeCount: number.isRequired,
    liked: bool.isRequired,
    isLoading: bool,
    useCaseEmbeds: arrayOf(shape({
      id: string.isRequired,
    })).isRequired,
  }).isRequired,
  currentIndex: number.isRequired,
  onUseCaseClick: func.isRequired,
  onMediaNav: func.isRequired,
  onLike: func.isRequired,
  onUnlike: func.isRequired,
  canUseLikeFeature: bool.isRequired,
  itemId: number,
  className: string,
  isNavHidden: bool,
  useLargeImage: bool,
}

export default MediaCard
